import React, {FC} from "react";
import NcImage from "components/NcImage/NcImage";
import rightImgDemo from "images/404.svg";
import ButtonPrimary from "components/Button/ButtonPrimary";
import NcLink from "../NcLink/NcLink";

export interface Section404 {
    className?: string;
    rightImg?: string;
}

const Section404: FC<Section404> = ({
                                        className = "",
                                        rightImg = rightImgDemo,
                                    }) => {
    return (
        <div
            className={`Section404 relative flex flex-col lg:flex-row items-center  ${className}`}
            data-id="Section404"
        >
            <div className="flex-shrink-0 mb-14 lg:mb-0 lg:mr-10 lg:w-2/5">
                <h2 className="font-semibold text-3xl sm:text-4xl mt-3">
                    Oops, Looks like you are lost in space...
                </h2>
                <span className="block mt-8 text-neutral-500 dark:text-neutral-400">
          Unfortunately, this page does not exist yet. Perhaps you would like to see our <NcLink
                    to="/frequently-asked-questions">Frequently Asked Questions</NcLink> or get some assistance from <NcLink
                    to="/contact">The CryptoVerse Support</NcLink>
        </span>
                <ButtonPrimary href="/" className="mt-8">Fly Home</ButtonPrimary>
            </div>
            <div className="flex-grow">
                <NcImage src={rightImg}/>
            </div>
        </div>
    );
};

export default Section404;
